import apiClient from 'api/apiConfig';

export const downloadLogData = async ({
  jobId,
  startTime,
}: {
  jobId: number;
  startTime: string;
}) => {
  const response = await apiClient.post(
    'csb/jobs/download-log',
    {
      CSBJobId: jobId,
      fromTimeCSB: startTime,
    },
    {
      headers: {
        'Content-Type': 'application/json',
      },
      responseType: 'blob',
    }
  );

  // Try to get filename from 'file-name' header first, then content-disposition
  const fileNameFromHeader = response.headers['file-name'];
  const fileNameFromDisposition = response.headers['content-disposition']
    ?.split('filename=')[1]
    ?.replace(/"/g, '');

  return {
    contentType: response.headers['content-type'] || 'text/plain',
    data: response.data,
    name: fileNameFromHeader || fileNameFromDisposition || `log-${jobId}.txt`,
  };
};
